import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Experience from './components/Experience';
import BirdingDashboard from './components/BirdingDashboard';
import Location from './components/Location';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import FloatingElements from './components/FloatingElements';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-emerald-900 via-slate-900 to-teal-900 relative overflow-hidden">
        <FloatingElements />
        <Navbar />
        
        <Routes>
          <Route path="/" element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8 }}
            >
              <Hero />
              <BirdingDashboard />
              <Experience />
              <Location />
              <Gallery />
            </motion.div>
          } />
        </Routes>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;